<template>
	<div class="add-product">
		<buyPannel
			:dialogBuyPannel="dialogBuyPannel"
			:stepsActive="active"
			:process="process"
			:state="payStatus"
			:orderNumber="orderNumber"
			:confirmRenew="confirmRenew"
			:iteminfo="iteminfo"
			v-on:cancelBuyPannel="cancelBuyPannel"
		>
		</buyPannel>
		<div
			v-for="(item1, index1) in appset"
			:key="index1"
			style="width: 100%; clear: both;"
		>
			<div
				style="color: var(--vtm-ink); font-size: 16px; font-weight: bold; margin-top: 5px;"
			>
				{{ item1.title }}
			</div>
			<div
				v-for="(item, index) in item1.list"
				:key="index"
				:class="item.classKuan"
				@mouseover="handleMouseOver(index1, index)"
				@mouseleave="handleMouseLeave(index1, index)"
				:style="
					$i18n.locale == 'zh_CN' || $i18n.locale == 'ja_JP'
						? 'float: left; margin: 15px 15px 0px 0px; background-color: var(--vtm-surface); border-radius: 8px; padding: 15px; display: flex; cursor: pointer; width: 293px;'
						: 'float: left; margin: 15px 15px 0px 0px; background-color: var(--vtm-surface); border-radius: 8px; padding: 15px; display: flex; cursor: pointer; width: 293px;'
				"
			>
				<img
					:src="item.icon"
					style="display: block; height: 55px; width: 55px; border-radius: 100%;"
				/>
				<div
					@click="handleEntry(item.url)"
					style="margin-left: 15px; width: 79%; height: 55px; display: flex; align-items: center;"
				>
					<div style="width: 100%;">
						<div style="display: flow-root;">
							<div
								:class="item.className"
								style="float: left; font-weight: 600; font-size: 18px;"
							>
								{{ item.title }}
							</div>
						</div>
						<div
							style="font-size: 14px; color: var(--vtm-ink-3); white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
						>
							{{ item.desc }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import buyPannel from "_c/myapps/BuyPannel";
export default {
	name: "PromoteConfig",
	components: {
		buyPannel,
	},
	data() {
		return {
			apps: {},
			logolist: [],
			iconlist: [],
			homeSignImglist: [],
			homeBackImglist: [],
			editorOption: {},
			appset: [
				{
					title: this.$t("myApps.myapp"),
					list: [
						{
							icon: require("_as/zhuti.png"),
							title: this.$t("theme.title"),
							desc: this.$t("theme.desc"),
							type: 0,
							price: 0,
							url: "/myapps/theme/list",
							className: "",
							classKuan: "xuanfuy",
						},
						// {
						//   icon: require("_as/guanggao.png"),
						//   title: this.$t("myApps.ggtf"),
						//   desc: this.$t("myApps.ggtfdesc"),
						//   type: 0,
						//   price: 0,
						//   url: "/myapps/adver/desktop",
						//   className: "",
						//   classKuan: "xuanfuy"
						// },
						{
							icon: require("_as/zhifufangshi.png"),
							title: this.$t("myApps.shoukuantitle"),
							desc: this.$t("myApps.shoukuandesc"),
							type: 0,
							price: 0,
							url: "/myapps/payment/index",
							className: "",
							classKuan: "xuanfuy",
						},
					],
				},
			],
			dialogBuyPannel: false,
			iteminfo: {},
			active: 0,
			process: "",
			payStatus: "",
			orderNumber: "",
			confirmRenew: "",
			localuserid: "",
		};
	},
	mounted() {
		let localuserid = sessionStorage.getItem("localuserid");
		if (localuserid) {
			this.localuserid = localuserid;
		}
	},
	methods: {
		handleEntry(url) {
			if (url) {
				this.$router.push(url);
			} else {
				this.$router.push("/myapps/ic");
			}
		},
		handleMouseOver(index1, index) {
			this.appset[index1]["list"][index]["className"] = "show";
			this.appset[index1]["list"][index]["classKuan"] = "xuanfu";
		},
		handleMouseLeave(index1, index) {
			this.appset[index1]["list"][index]["className"] = "";
			this.appset[index1]["list"][index]["classKuan"] = "xuanfuy";
		},
		cancelBuyPannel(dialog, state) {
			this.dialogBuyPannel = dialog;
			if (state) {
				this.currentChange();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.xuanfu {
	border: 1px solid var(--vtm-mint);
}
.xuanfuy {
	border: 1px solid var(--vtm-surface);
}
.show {
	color: var(--vtm-mint-ink);
}
.editor {
	height: 300px;
}
.el-form--label-top .el-form-item__label {
	padding: 0;
}
.add-product {
	background-color: var(--vtm-well);
	display: flow-root;
	padding-bottom: 15px;
	.el-upload--picture-card {
		width: 80px;
		height: 80px;
		line-height: 88px;
	}
	.el-upload-list__item {
		width: 80px !important;
		height: 80px !important;
		margin-bottom: 0 !important;
	}
	.el-form-item__content {
		line-height: 0;
	}
}
</style>
